/**
 * Safely converts a field value to text for copy selection. A value whose toString is absent, throws,
 * or returns a non-string is deliberately left unreadable rather than allowing validation to throw.
 */
export function stringifyForCounting(value: unknown): string | undefined {
	if (value === null || value === undefined) {
		return "";
	}
	try {
		if (Array.isArray(value)) {
			return value.join(", ");
		}
		const stringified = (value as { toString?: () => unknown }).toString?.();
		return typeof stringified === "string" ? stringified : undefined;
	} catch {
		return undefined;
	}
}

/** Returns the shared character-limit copy for a generic or named field. */
export function defaultOverflowMessage(maxLength: number, fieldNoun: string | undefined, value: unknown): string {
	if (!fieldNoun) {
		return `Must not exceed ${maxLength} characters.`;
	}
	const text = stringifyForCounting(value) ?? "";
	const hasEmojiOrAccentedText = /[\p{Extended_Pictographic}\p{Mark}]/u.test(text.normalize("NFD"));
	return hasEmojiOrAccentedText
		? `Please enter a shorter ${fieldNoun} (emojis and accent may take extra space).`
		: `Please enter a shorter ${fieldNoun}.`;
}
